// import { useState } from "react";
import "./Navbar.css"

const Navbar = () => {

    // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    // const toggleMenu = () => {
    //     setIsMobileMenuOpen(!isMobileMenuOpen);
    // }

    return (
        <div>
            {/* navbar upper drop down */}
            <div>

            </div>

            {/* image */}
            <div className="navbar_img">
                <img
                    src="images/new4.jpg"
                    alt="Logo"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                />
                <img
                    src="images/merge_from_ofoct.gif"
                    alt="gif"
                    style={{
                        position: "absolute",
                        left:0,
                        width: "40%",
                        height: "100%"
                    }} />
                <img
                    src="images/energy.png"
                    alt="source"
                    style={{
                        position: "absolute",
                        left: "40%",
                        width: "8vw",
                        height: "100%"
                    }}
                />



            </div>


            {/* <nav className="navbar">
                <div className="hamburger" onClick={toggleMenu}>
                    &#9776;
                </div>
                <ul className={`nav-menu ${isMobileMenuOpen ? "active" : ""}`}>
                    <li className="nav-item"><a href="">Home</a></li>
                    <li className="nav-item"><a href="#">About</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/history.html'>History of HPSEBL</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/organization.html'>Organization</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/mision.html'>Mission/Vision</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/photogallery.htm'>Photo Gallery</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">Electricity Traiff</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/tariff2.html'>Current Schedule of Traiff</a></li>
                            <li><a href='https://webdocuploader.hpseb.in/uploader/download2.php?link=/portal/currenttariffrates/inc.pdf'>IPPC/FSA Notification</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/bill_estimation.html'>Bill Estimation</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">IT Initiatives</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/erp.html'>ERP(Enterprise Resource Planning)</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/rapdrp.html'>R-APDRP</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/computerizedbilling.html'>Computerized Billing</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/itsecurity.html'>IT Security</a></li>
                        </ul>
                    </li>
                    <li className="nav-item" ><a href="#">Tenders</a>
                        <ul className="dropdown">
                            <li><a href='https://hptenders.gov.in/nicgep/app'>E-Tendering (hptenders.gov.in)</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/tender.html'>NIT/NIQ/Corrigendum</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">SERC</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/myt.html'>Multi Year Tariff/Orders</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/petitions.html'>Petitions</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/reviewpetitions.html'>Review Petitions</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/ppa.html'>Power Purchase Agreement</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/costdata.html'>Cost Data/EHV Transmission</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/solar.html'>Solar</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/ccr.htm'>Consumer Credit Rating</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/t&dlosses.html'>Circle wise T&D/AT&C losses</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">RTI</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/rti.html'>RTI Home</a></li>
                            <li><a href='https://webdocuploader.hpseb.in/uploader/download2.php?link=/portal/rti/PIO%20Appellate%20Authority%20and%20Nodal%20Officers.pdf'>Appelate Authority</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/assetsliabilites.html'>Assets & Liabilites</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/books.html'>Manuals & Books</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">Citizen Interface</a>
                        <ul className="dropdown">
                            <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/citizeninterface.htm'>Citizen Interface</a></li>
                            <li ><a href='https://webdocuploader.hpseb.in/uploader/cgrforders'>CGRF(Consumer Griveance Redressal Forum)</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/ombudsman.html'>Ombudsman</a></li>
                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">Investor Relations</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/Disclosure%20of%20informations.html'>Disclosure under Regulation 62 of SEBI</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/HPSEBL/whatsnew/moa_1.pdf'>Memorandum of Association</a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/Details%20of%20Directors.html'>Details of Directors & KMP </a></li>
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/corpannouncements.html'>Corporate Announcements</a></li>
                            <li className="dropdown-subitem"><a href='#'>Financial Performance/Data</a>
                                <ul className="sub-dropdown">
                                    <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/reports.html'>Annual Reports</a></li>
                                    <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/policies.html'>Polices</a></li>
                                </ul>
                            </li>
                            <li className="dropdown-subitem"><a href='#'>Investor Services</a>
                                <ul className="sub-dropdown">
                                    <li ><a href='https://webdocuploader.hpseb.in/uploader/download2.php?link=/portal/bse/Certificate for payment of Interest.pdf'>Payment of Interest</a></li>
                                    <li ><a href='https://webdocuploader.hpseb.in/uploader/download2.php?link=/portal/bse/Details of Debenture as on 31.03.2022.pdf'>Debentures Deatails(Scip Code,ISIN,Amt)</a></li>
                                    <li ><a href=''>IEEF(NIL TIL DATE)</a></li>
                                </ul>
                            </li>
                            <li className="dropdown-subitem"><a href='#'>Contact Name/Address</a>
                                <ul className="sub-dropdown">
                                    <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/HPSEBL/whatsnew/axistrustee.jpg'>Name of Trustee/Address</a></li>
                                    <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/HPSEBL/whatsnew/rtabeetal.jpg'>Name of Trustee(RTA)/Address</a></li>
                                </ul>
                            </li>

                        </ul>
                    </li>
                    <li className="nav-item"><a href="#">Citizen Interface</a>
                        <ul className="dropdown">
                            <li><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/email.html'>Email IDs</a></li>
                            <li><a href='https://onlineportal.hpsebl.in/feedback/default.aspx'>FeedBack</a></li>
                            <li ><a href='https://www.hpseb.in/irj/go/km/docs/internet/New_Website/Pages/contact.htm'>Contact Details of Officers</a></li>
                        </ul>
                    </li>
                </ul>
            </nav> */}

        </div>

    )
}

export default Navbar;